import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// mui
import { Button, Stack, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
// component
import TopBackButton from '@/component/common/top-back-button';
import BottomFix from '@/component/common/bottom-fix';

export default function SendFail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    state: { data },
  } = useLocation();
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '653px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title="보내기 실패"
        boxProps={{
          mb: 4,
        }}
        backPath={'/wallet'}
      />
      <Box mb={7} />
      <Box
        sx={{
          textAlign: 'left',
        }}
      >
        <Stack
          spacing={2}
          sx={{
            verticalAlign: 'middle',
            textAlign: 'center',
            // paddingLeft: 8,
          }}
        >
          전송되지 않았거나 전송이 보류 상태일 수 있습니다. <br />
          <Box mb={2} />
          스캔에서 확인해주세요.
        </Stack>
        <Box mb={15} />
        <Typography variant="h5" mb={1}>
          ※ Fail reason
        </Typography>
        <Box sx={{ wordBreak: 'break-all' }}>{data}</Box>
        <Box mb={3} />
        <BottomFix>
          <Button
            sx={{
              my: 2,
            }}
            variant="contained"
            size="large"
            fullWidth
            onClick={() => {
              navigate('/wallet');
            }}
          >
            확인
          </Button>
        </BottomFix>
      </Box>
    </Container>
  );
}
